import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "gg_auth_token";
export const authHeader = () => {
  const t = localStorage.getItem(TOKEN_KEY);
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};

export const fetchLocations = async () => (await axios.get(`${API}/locations`)).data;

export const fetchRates = async (location) =>
  (await axios.get(`${API}/rates`, { params: { location } })).data;

export const calculateEstimate = async (payload) =>
  (await axios.post(`${API}/quote/calculate`, payload, authHeader())).data;

export const saveQuote = async (payload) => (await axios.post(`${API}/quotes`, payload, authHeader())).data;

export const getQuote = async (reference) => (await axios.get(`${API}/quotes/${reference}`)).data;

export const emailQuote = async (reference) =>
  (await axios.post(`${API}/quotes/${reference}/email`)).data;

// --- Auth (passwordless email OTP) ---
export const requestCode = async (email) =>
  (await axios.post(`${API}/auth/request-code`, { email })).data;

export const verifyCode = async (email, code) =>
  (await axios.post(`${API}/auth/verify-code`, { email, code })).data;

export const getMe = async () => (await axios.get(`${API}/auth/me`, authHeader())).data;

export const subscribeInterest = async () =>
  (await axios.post(`${API}/subscribe/interest`, {}, authHeader())).data;

export const adminLogin = async (passcode) =>
  (await axios.post(`${API}/admin/login`, { passcode })).data;

const adminHeaders = (passcode) => ({ headers: { "X-Admin-Passcode": passcode } });

export const getAdminMetros = async (passcode) =>
  (await axios.get(`${API}/admin/metros`, adminHeaders(passcode))).data;

export const saveAdminMetro = async (passcode, body) =>
  (await axios.put(`${API}/admin/metros`, body, adminHeaders(passcode))).data;

export const resetAdminMetro = async (passcode, key) =>
  (await axios.delete(`${API}/admin/metros/${encodeURIComponent(key)}`, adminHeaders(passcode))).data;

export const getAdminZips = async (passcode) =>
  (await axios.get(`${API}/admin/zips`, adminHeaders(passcode))).data;

export const saveAdminZip = async (passcode, body) =>
  (await axios.put(`${API}/admin/zips`, body, adminHeaders(passcode))).data;

export const deleteAdminZip = async (passcode, zip) =>
  (await axios.delete(`${API}/admin/zips/${encodeURIComponent(zip)}`, adminHeaders(passcode))).data;

export const bulkImportZips = async (passcode, csv) =>
  (await axios.post(`${API}/admin/zips/bulk`, { csv }, adminHeaders(passcode))).data;

export const getAdminSettings = async (passcode) =>
  (await axios.get(`${API}/admin/settings`, adminHeaders(passcode))).data;

export const saveAdminSettings = async (passcode, body) =>
  (await axios.put(`${API}/admin/settings`, body, adminHeaders(passcode))).data;

export const getAdminQuotes = async (passcode) =>
  (await axios.get(`${API}/admin/quotes`, adminHeaders(passcode))).data;

export const getAdminUsage = async (passcode) =>
  (await axios.get(`${API}/admin/usage`, adminHeaders(passcode))).data;
